enum PubSubSessionActionEnum
{
	REGISTERED = "registered",
	REGISTERED_ON_WAITLIST = "registered-on-waitlist",
	REGISTERED_ON_RESERVED_SPOT = "registered-on-reserved-spot",
	REGISTERED_FROM_WAITLIST = "registered-from-waitlist",
	REGISTERED_FROM_CAPACITY_INCREASE = "registered-from-capacity-increase",

	UNREGISTERED = "unregistered",
	UNREGISTERED_LATE = "unregistered-late",
	UNREGISTERED_FROM_WAITLIST = "unregistered-from-waitlist",
	UNREGISTERED_FROM_RESERVED_SPOT = "unregistered-from-reserved-spot",
	UNREGISTERED_RESERVED_SPOT_EXPIRED = "unregistered-reserved-spot-expired",

	ATTENDANCE_UPDATED = "attendance-updated",
	NOTE_FOR_COACH_UPDATED = "note-for-coach-updated",
}

export default PubSubSessionActionEnum;
